// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3mxvk","range":"MonthRangeSwitch_range__19TUv","disabled":"MonthRangeSwitch_disabled__wjG10"};